import { ClearAgencyCache } from './AgencyAPI';
import { useUserData } from 'Foundation/User/UserContext';
import { FunctionComponent, useEffect, useState } from 'react';
import { AlphanumericInput } from '@lmig/lmds-react-alphanumeric-input';
import { Form } from '@lmig/lmds-react-form';
import { Button } from '@lmig/lmds-react-button';
import { GridCol, GridRow } from '@lmig/lmds-react-grid';
import { FieldGroup } from '@lmig/lmds-react-field-group';

const AgencyCacheTool: FunctionComponent = () => {
  const [agencyCode, setAgencyCode] = useState<string>('');
  const [isAgencyCodeValid, setIsAgencyCodeValid] = useState<boolean>(false);
  const [keysCleared, setClearedKeys] = useState<string>('');
  const { userData } = useUserData();
  const validAgencyCode = new RegExp('\\d{7}');

  const updateAgencyCode = (e: any) => {
    setAgencyCode(e.target.value);
  };

  useEffect(() => {
    if (validAgencyCode.test(agencyCode)) {
      setIsAgencyCodeValid(true);
    } else {
      setIsAgencyCodeValid(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agencyCode]);

  const submitClearCache = async () => {
    if (userData && !userData.isAgent() && isAgencyCodeValid) {
      var response = await ClearAgencyCache(agencyCode);
      if (response != null && response !== '') {
        alert(`There were ${response} keys cleared related to that agency`);
        setClearedKeys(response);
        if (keysCleared) {
          console.log(keysCleared);
        }
      }
    }
  };

  return userData && !userData.isAgent() ? (
    <>
      <div className="agency-cache-tool">
        <div className="menu-section-links">
          <Form onSubmit={submitClearCache}>
            <GridRow gutters justify="center">
              <GridCol base={8}>
                <FieldGroup
                  labelStyle="h3-light"
                  labelTag="h3"
                  labelVisual="Agency Cache Tool"
                  instructions="Enter an agency code and submit to clear the data associated with that agency from the Redis cache."
                  messages={[
                    isAgencyCodeValid || !agencyCode
                      ? {}
                      : {
                          text: 'The agency code should be a 7 digit number',
                          type: 'error',
                        },
                  ]}
                >
                  <AlphanumericInput
                    labelVisual="Agency Code"
                    onBlur={updateAgencyCode}
                    highlightType={isAgencyCodeValid || !agencyCode ? undefined : 'error'}
                  />
                  <Button dynamicWidth variant="primary" type="submit" className="btnSubmit">
                    Clear Redis cache
                  </Button>
                </FieldGroup>
              </GridCol>
            </GridRow>
          </Form>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

export default AgencyCacheTool;
